<template>
  <div v-if="selecionado" class="item-viewer">
    <button v-if="habilitarEdicaoDepositosCarrinho" type="button" class="item-viewer-fechar"
        aria-label="Fechar detalhes do produto" title="Fechar" @click="$emit('fechar')">
        <i class="material-icons">close</i>
    </button>
    <section class="item-viewer-topo" aria-label="Resumo do produto">
        <div class="item-viewer-foto">
            <img :src="selecionado.fotoAlta" :alt="selecionado.itemDescricao || 'Foto do produto'">
        </div>
        <div class="item-viewer-resumo">
            <span class="item-viewer-kicker">Detalhes do produto</span>
            <button v-if="similaresHabilitados && temSimilares" type="button"
                class="waves-effect waves-light btn" title="Ver itens similares" aria-label="Ver itens similares"
                @click="$emit('verSimilares', selecionado, similaresDisponiveis)">
                <i class="material-icons left" aria-hidden="true">compare_arrows</i>
                {{ similaresDisponiveis.length }} {{ similaresDisponiveis.length === 1 ? 'ITEM SIMILAR' : 'ITENS SIMILARES' }}
            </button>
            <h4 class="item-viewer-nome">
                <i class="material-icons" v-if="exibirIndicadorMrg"
                    :class="definirCorMrgDet(selecionado)">brightness_1</i>
                {{ selecionado.itemDescricao }}
            </h4>
            <div class="item-viewer-identificacao">
                <span v-if="selecionado.itemSku">{{ dicionario.item_codigo }}: <strong>{{ selecionado.itemSku }}</strong></span>
                <span v-if="selecionado.itemSkuFabricante">{{ dicionario.item_sku_fabricante }}: <strong>{{ selecionado.itemSkuFabricante }}</strong></span>
            </div>
            <p v-if="selecionado.itemTextoBloqueio" class="item-viewer-aviso">{{ selecionado.itemTextoBloqueio }}</p>

            <div v-if="exibirPreco" class="item-viewer-valores">
                <div class="item-viewer-preco-principal">
                    <span>Preço unitário</span>
                    <div>
                        <strong>{{ valoresExibicao.valorTabela | grana }}</strong>
                        <span v-if="!ocultarPrazoAdicional && Number(selecionado.depoQtdDiasAdicionaisEntrega) > 0" class="prazo-entrega-adicional">D+{{ selecionado.depoQtdDiasAdicionaisEntrega }}</span>
                    </div>
                </div>
                <div class="item-viewer-valores-grid">
                    <div>
                        <span>Desconto</span>
                        <strong :class="priceClass">{{ valoresExibicao.percDesc }}%</strong>
                        <small v-if="valoresExibicao.qtdMin > 1">Mínimo de {{ valoresExibicao.qtdMin }} peças</small>
                        <small v-if="valoresExibicao.qtdMax">Máximo de {{ valoresExibicao.qtdMax }} peças</small>
                    </div>
                    <div><span>Valor líquido</span><strong>{{ valoresExibicao.vlComDesc | grana }}</strong></div>
                    <div><span>Subst. tributária</span><strong>{{ valoresExibicao.vlIcmsSt | grana }}</strong></div>
                    <div v-if="podeVisualizarQuantidadeEstoque" :class="{ 'estoque-original-destaque': limitarQuantidadeDepositos }"><span>Disponibilidade</span><strong>{{ valoresExibicao.qtdDisponivel }} {{ valoresExibicao.unidade }}</strong></div>
                </div>
                <div class="item-viewer-total">
                    <span>Total com impostos</span>
                    <strong :class="priceClass">{{ valoresExibicao.vlTotal | grana }}</strong>
                </div>
                <div v-if="habilitarFuncaoAdicionarCarrinho && !habilitarSelecaoMultiEmpresa" class="item-viewer-adicionar-valores">
                    <label v-if="!selecionado.itemTextoBloqueio" for="qtd_adicionar">Quantidade</label>
                    <input v-if="!selecionado.itemTextoBloqueio" id="qtd_adicionar" type="number" min="0"
                        v-model="quantidadeSelecionada" :step="env && env.pedido_multiplicar_quantidade_digitada_embalagem ? selecionado.itemEmbMult : 1"
                        @wheel="$event.target.blur()" @change="checkQuantidadeDeposito">
                    <span>Total a adicionar</span>
                    <strong id="sp-total" :class="priceClass">{{ (selecionado.tempValorTotal * quantidadeSelecionada) | grana }}</strong>
                </div>
            </div>
            <div v-if="habilitarFuncaoAdicionarCarrinho && !habilitarSelecaoMultiEmpresa && !selecionado.itemTextoBloqueio"
                class="item-viewer-adicionar-acao">
                <p v-if="mapItensPedidoAberto == null || mapItensPedidoAberto[`${selecionado.itemId}`] || mensagemExtraAdicaoView" class="item-viewer-aviso">
                    <span v-if="!mapItensPedidoAberto">Não há pedido aberto para o cliente selecionado, um novo pedido será criado.</span>
                    <span v-else-if="mapItensPedidoAberto[`${selecionado.itemId}`]">Este produto já foi adicionado ao carrinho</span>
                    <span v-else>{{ mensagemExtraAdicaoView }}</span>
                </p>
                <a v-if="mapItensPedidoAberto == null || !mapItensPedidoAberto[`${selecionado.itemId}`]"
                    @click.prevent="adicionarCarrinhoPelaVisualizacao(selecionado)"
                    class="waves-effect waves-light btn-large btn">
                    <i class="material-icons left">add_shopping_cart</i>Adicionar ao Pedido
                </a>
            </div>
        </div>
    </section>
    <section v-if="exibirEstoquesDepositos && (carregandoEstoquesDepositos || estoquesDepositos.length || erroEstoquesDepositos)"
        class="item-viewer-secao multiempresa-carrinho-viewer">
        <h5 class="multiempresa-carrinho-viewer-title">
            <i class="material-icons tiny">business</i>
            Itens por Centro de Distribuição
        </h5>
        <p v-if="carregandoEstoquesDepositos" class="item-viewer-secao-descricao">Consultando os depósitos configurados...</p>
        <p v-else-if="erroEstoquesDepositos" class="item-viewer-secao-descricao red-text">Não foi possível consultar os estoques dos demais depósitos.</p>
        <div v-else class="multiempresa-carrinho-viewer-cards">
            <div v-for="opcao in opcoesEstoqueDepositos" :key="opcao.itemId"
                class="card multiempresa-carrinho-viewer-card">
                <div class="multiempresa-carrinho-viewer-card-header">
                    <div>
                        <b class="multiempresa-carrinho-viewer-card-filial">{{ nomeDeposito(opcao) }}</b>
                        <span v-if="opcao.itemId === selecionado.itemId" class="new badge teal"
                            data-badge-caption="padrão"></span>
                        <span v-if="Number(opcao.depoQtdDiasAdicionaisEntrega) > 0" class="prazo-entrega-adicional">D+{{ opcao.depoQtdDiasAdicionaisEntrega }}</span>
                        <div class="grey-text fonte ultra-small">idItem {{ opcao.itemId }}</div>
                    </div>
                </div>
                <div class="multiempresa-carrinho-viewer-card-info">
                    <div v-if="exibirPreco" class="multiempresa-carrinho-viewer-card-preco">
                        <span class="grey-text fonte ultra-small">Preço unitário</span>
                        <div class="multiempresa-carrinho-viewer-card-preco-valor">
                            <strong>{{ precoUnitarioOpcao(opcao) | granars }}</strong>
                        </div>
                    </div>
                    <div class="right-align multiempresa-carrinho-viewer-card-estoque">
                        <span class="grey-text fonte ultra-small">{{ podeVisualizarQuantidadeEstoque ? 'Estoque' : 'Unid. Med.' }}</span>
                        <strong v-if="podeVisualizarQuantidadeEstoque"
                            :class="Number(opcao.depiQtdDisponivel) > 0 ? 'green-text text-darken-2' : 'red-text'">
                            {{ Number(opcao.depiQtdDisponivel) > 0 ? opcao.depiQtdDisponivel + ' ' + opcao.itemUnidade : 'Sem estoque' }}
                        </strong>
                        <strong v-else>{{ opcao.itemUnidade }}</strong>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section v-if="habilitarEdicaoDepositosCarrinho && opcoesDepositoCarrinho.length"
        class="item-viewer-secao multiempresa-carrinho-viewer">
            <h5 class="multiempresa-carrinho-viewer-title">
                <i class="material-icons tiny">business</i>
                Itens por Centro de Distribuição
            </h5>
            <p class="item-viewer-secao-descricao">Confira preço e disponibilidade e ajuste a quantidade em cada depósito.</p>
            <div class="multiempresa-carrinho-viewer-cards">
                <div v-for="opcao in opcoesDepositoCarrinhoOrdenadas" :key="opcao.peddId || opcao.itemId"
                    class="card multiempresa-carrinho-viewer-card">
                    <div class="multiempresa-carrinho-viewer-card-header">
                        <div>
                            <b class="multiempresa-carrinho-viewer-card-filial">{{ opcao.emprNome }}</b>
                            <span v-if="itemDaEmpresaPedidoCarrinho(opcao)" class="new badge teal"
                                data-badge-caption="padrão"></span>
                            <span v-if="Number(opcao.depoQtdDiasAdicionaisEntrega) > 0" class="prazo-entrega-adicional">D+{{ opcao.depoQtdDiasAdicionaisEntrega }}</span>
                            <div class="grey-text fonte ultra-small">idItem {{ opcao.itemId }}</div>
                        </div>
                        <button v-if="opcao.peddId" type="button"
                            class="item-viewer-remover-deposito red-text"
                            :title="`Remover item de ${opcao.emprNome}`"
                            :aria-label="`Remover item de ${opcao.emprNome}`"
                            @click="$emit('removerItemCarrinho', opcao)">
                            <i class="material-icons" aria-hidden="true">delete</i>
                            <span>Remover</span>
                        </button>
                    </div>
                    <div class="multiempresa-carrinho-viewer-card-info">
                        <div class="multiempresa-carrinho-viewer-card-preco">
                            <span class="grey-text fonte ultra-small">Preço unitário</span>
                            <div class="multiempresa-carrinho-viewer-card-preco-valor">
                                <strong>{{ opcao.peddVlUnitLiq | granars }}</strong>
                            </div>
                        </div>
                        <div class="right-align multiempresa-carrinho-viewer-card-estoque">
                            <span class="grey-text fonte ultra-small">{{ exibirEstoqueDepositos ? 'Estoque' : 'Unid. Med.' }}</span>
                            <strong v-if="exibirEstoqueDepositos"
                                :class="Number(opcao.depiQtdDisponivel) > 0 ? 'green-text text-darken-2' : 'red-text'">
                                {{ Number(opcao.depiQtdDisponivel) > 0 ? opcao.depiQtdDisponivel + ' ' + opcao.itemUnidade : 'Sem estoque' }}
                            </strong>
                            <strong v-else>{{ opcao.itemUnidade }}</strong>
                        </div>
                    </div>
                    <div class="multiempresa-carrinho-viewer-card-quantidade">
                        <label :for="`qtd-multiempresa-popup-${opcao.peddId || opcao.itemId}`">Quantidade</label>
                        <input :id="`qtd-multiempresa-popup-${opcao.peddId || opcao.itemId}`" type="number" min="0"
                            v-model.lazy="opcao.peddQuantidade"
                            :max="limitarQuantidadeDepositos && maximoQuantidadeCarrinho ? maximoQuantidadeCarrinho(opcao) : null"
                            :disabled="!opcao.peddId && Number(opcao.depiQtdDisponivel) <= 0 && !(env && env.trabalha_com_lista_de_falta)"
                            :step="env && env.pedido_multiplicar_quantidade_digitada_embalagem ? opcao.itemEmbMult : 1"
                            @wheel="$event.target.blur()"
                            @focus="$emit('preservarQuantidadeCarrinho', opcao)"
                            @change="$emit('alterarQuantidadeCarrinho', opcao)">
                    </div>
                </div>
            </div>
    </section>
    <div v-if="habilitarSelecaoMultiEmpresa"
        class="row multiempresa-viewer">
        <div class="col s12 white z-depth-1 pa-1">
            <h5 class="multiempresa-viewer-title">
                <i class="material-icons">business</i>
                {{ tituloDisponibilidadeMultiEmpresa }}
            </h5>
            <div class="multiempresa-viewer-table">
                <table class="striped responsive-table">
                    <thead>
                        <tr>
                            <th>Empresa / item</th>
                            <th class="right-align">Preço unitário</th>
                            <th class="right-align">{{ exibirEstoqueDepositos ? 'Estoque' : 'Unid. Med.' }}</th>
                            <th class="right-align">Quantidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="opcao in itensDisponiveisMultiEmpresa" :key="opcao.itemId">
                            <td>
                                <b>{{ opcao.emprNome || 'Empresa do pedido' }}</b>
                                <span v-if="opcao.empresaOriginal" class="new badge teal" data-badge-caption="padrão"></span>
                                <span v-if="Number(opcao.depoQtdDiasAdicionaisEntrega) > 0" class="prazo-entrega-adicional">D+{{ opcao.depoQtdDiasAdicionaisEntrega }}</span>
                                <br>
                                <span class="grey-text">idItem {{ opcao.itemId }}</span>
                                <span v-if="itemJaNoPedido(opcao)" class="red-text"><br>Este item já está no pedido</span>
                                <span v-else-if="opcao.itemTextoBloqueio" class="red-text"><br>{{ opcao.itemTextoBloqueio }}</span>
                            </td>
                            <td class="right-align"><b>{{ precoUnitarioOpcao(opcao) | granars }}</b></td>
                            <td class="right-align"
                                :class="exibirEstoqueDepositos ? (Number(opcao.depiQtdDisponivel) > 0 ? 'green-text text-darken-2' : 'red-text') : ''">
                                <b v-if="exibirEstoqueDepositos">{{ Number(opcao.depiQtdDisponivel) > 0 ? opcao.depiQtdDisponivel + ' ' + opcao.itemUnidade : 'Sem estoque' }}</b>
                                <b v-else>{{ opcao.itemUnidade }}</b>
                            </td>
                            <td class="right-align multiempresa-viewer-quantidade">
                                <input type="number" min="0" v-model.lazy.number="opcao.quantidadeSelecionada"
                                    :max="limitarQuantidadeDepositos ? maximoQuantidadeDeposito(opcao) : null"
                                    :disabled="itemJaNoPedido(opcao) || !!opcao.itemTextoBloqueio || (Number(opcao.depiQtdDisponivel) <= 0 && !trabalhaComListaDeFalta)"
                                    :step="env && env.pedido_multiplicar_quantidade_digitada_embalagem ? opcao.itemEmbMult : 1"
                                    @change="corrigirQuantidadeOpcao(opcao)" @wheel="$event.target.blur()">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row multiempresa-viewer-actions">
                <div class="col s12 m7 fonte small grey-text text-darken-1">
                    {{ quantidadeOpcoesSelecionadas }} empresa<span v-if="quantidadeOpcoesSelecionadas !== 1">s</span> selecionada<span v-if="quantidadeOpcoesSelecionadas !== 1">s</span>
                    <br>
                    Total estimado: <b>{{ totalMultiEmpresa | granars }}</b>
                </div>
                <div class="col s12 m5">
                    <a @click.prevent="adicionarItensMultiEmpresa"
                        class="col s12 waves-effect waves-light btn-large btn right"
                        :class="{ disabled: quantidadeOpcoesSelecionadas === 0 }">
                        <i class="material-icons left">add_shopping_cart</i>
                        Adicionar selecionados
                    </a>
                </div>
            </div>
        </div>
    </div>
    <section class="item-viewer-secao item-viewer-tecnicos">
        <h5><i class="material-icons">tune</i>Informações técnicas</h5>
        <div class="item-viewer-tecnicos-grid">
            <div><span>{{ dicionario.item_codigo }}</span><strong>{{ selecionado.itemSku }}</strong></div>
            <div><span>{{ dicionario.item_ref_externo }}</span><strong>{{ selecionado.itemRefExterno || '—' }}</strong></div>
            <div><span>{{ dicionario.item_sku_fabricante }}</span><strong>{{ selecionado.itemSkuFabricante || '—' }}</strong></div>
            <div><span>{{ dicionario.atributo_1 }}</span><strong>{{ selecionado.itemAtributo1 || '—' }}</strong></div>
            <div><span>{{ dicionario.atributo_2 }}</span><strong>{{ selecionado.itemAtributo2 || '—' }}</strong></div>
            <div><span>NCM</span><strong>{{ selecionado.itemNcm || '—' }}</strong></div>
            <div v-if="dimensoesProduto"><span>Dimensões</span><strong>{{ dimensoesProduto }}</strong></div>
            <div v-if="pesoProduto"><span>Peso</span><strong>{{ pesoProduto }}</strong></div>
            <div><span>Código de barras</span><strong>{{ itemInfoComplementar && itemInfoComplementar.itemCodbarras || '—' }}</strong></div>
            <div><span>Código CST</span><strong>{{ selecionado.codcst || '—' }}</strong></div>
            <div>
                <span>PIS/Cofins</span>
                <strong v-if="selecionado.itemInPis == 'M'">Monofásico</strong>
                <strong v-else-if="selecionado.itemInPis == 'C'">Cumulativo</strong>
                <strong v-else>Não definido</strong>
            </div>
            <div><span>Garantia</span><strong>{{ selecionado.itemTextoGarantia || '—' }}</strong></div>
            <div v-if="selecionado.descricaoAdicional" class="item-viewer-tecnico-largo">
                <span>Descrição adicional</span><div v-html="selecionado.descricaoAdicional"></div>
            </div>
            <div v-if="descritivoHtml" class="item-viewer-tecnico-largo">
                <span>Aplicação
                    <button v-if="textoAplicacao" type="button" class="item-viewer-copiar" title="Copiar aplicação" aria-label="Copiar aplicação"
                        @click.prevent="copiarAplicacao"><i class="material-icons">content_copy</i></button>
                </span>
                <div v-html="descritivoHtml"></div>
            </div>
            <template v-if="env && env.vizualizar_sincronia_fraga_iten_detalhe && itemInfoComplementar">
                <div><span>ID Fraga</span><strong>{{ itemInfoComplementar.itemIdFraga || 'Não sincronizado' }}</strong></div>
                <div><span>Última sincronia Fraga</span>
                    <strong v-if="itemInfoComplementar.itemDthUltSincronizacaoFraga">{{ itemInfoComplementar.itemDthUltSincronizacaoFraga | datahora }}</strong>
                    <strong v-else>Não sincronizado</strong>
                </div>
            </template>
            <div v-if="env && env.usar_descricao_adicional_item && selecionado.descricaoAdicional" class="item-viewer-tecnico-largo">
                <span>Descrição</span><strong>{{ selecionado.descricaoAdicional.replace(/(<([^>]+)>)/ig, '') }}</strong>
            </div>
            <div v-if="selecionado.depiQtdPedCompra && selecionado.depiQtdPedCompra > 0 && selecionado.previsaoChegada && env && env.exibir_pedido_compra && usuario && usuario.usuaRole !== 'CLIENTE'">
                <span>Previsão de chegada</span><strong>{{ selecionado.previsaoChegada }}</strong>
            </div>
            <div v-if="itemInfoComplementar && itemInfoComplementar.itemTextoLivreEcom" class="item-viewer-tecnico-largo">
                <span>Informações complementares</span><strong>{{ itemInfoComplementar.itemTextoLivreEcom }}</strong>
            </div>
            <div v-if="itemInfoComplementar && itemInfoComplementar.itemUrlVideo" class="item-viewer-tecnico-largo">
                <span>Vídeo</span><a :href="itemInfoComplementar.itemUrlVideo" target="_blank" rel="noopener noreferrer">{{ itemInfoComplementar.itemUrlVideo }}</a>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
import { ordenarPorIdDeposito } from '../../helpers/OrdenacaoDepositosHelper';
import { quantidadeMaximaDeposito, ajustarQuantidadeDeposito, quantidadesDepositosValidas } from '../../helpers/LimiteQuantidadeDepositosHelper';
import StHelper from '../../helpers/StHelper';
import ServiceFactory from '../../services/ServiceFactory';

export default {
  name: 'item-viewer',
  props:{
		exibirPreco: { type: Boolean, default: true },
	selecionado: null,
	dicionario: null,
	usuario: null,
	habilitarFuncaoAdicionarCarrinho:null,
	mapItensPedidoAberto: null,
	quantidadeSelecionada:null,
	trabalhaComListaDeFalta:null,
    ehItemPedido: false,
	mostrarMarkupCliente: {type:Boolean, default:false},
    habilitarSelecaoMultiEmpresa: {type:Boolean, default:false},
    limitarQuantidadeDepositos: {type:Boolean, default:false},
    estoqueOriginalDisponivel: {default:null},
    maximoQuantidadeCarrinho: {type:Function, default:null},
    ocultarPrazoAdicional: {type:Boolean, default:false},
    habilitarEdicaoDepositosCarrinho: {type:Boolean, default:false},
    exibirEstoquesDepositos: {type:Boolean, default:false},
    opcoesDepositoCarrinho: {type:Array, default:() => []},
    emprIdPedidoCarrinho: null,
    clienteSelecionado: null,
    tabelaPreco: null,
    env:null,
  },
  data() {
      return {
        itemService: null,
        itemInfoComplementar: null,
        estoquesDepositos: [],
        carregandoEstoquesDepositos: false,
        erroEstoquesDepositos: false,
        consultaEstoquesDepositos: 0,
        consultaSimilares: 0,
        similaresDisponiveis: [],
      }
  	},
	computed: {
        temSimilares: function () { return this.similaresDisponiveis.length > 0; },
        similaresHabilitados: function () {
            const chave = this.ehItemPedido ? 'exibir_icone_similares_carrinho' : 'exibir_icone_similares_busca_produtos';
            const valor = this.env && this.env[chave];
            return !!this.$listeners.verSimilares && valor !== false && String(valor).toLowerCase() !== 'false';
        },
        exibirEstoqueDepositos: function () {
            return this.podeVisualizarQuantidadeEstoque && !this.limitarQuantidadeDepositos;
        },
		podeVisualizarQuantidadeEstoque: function () {
			return !!(this.env && this.usuario && this.env.roles_visualizam_qtd_item_disponivel &&
				this.env.temPerfil(this.usuario.usuaRole, this.env.roles_visualizam_qtd_item_disponivel.split(';')));
		},
		tituloDisponibilidadeMultiEmpresa: function () {
			const tituloConfigurado = this.env && this.env.titulo_disponibilidade_multiempresa;
			return tituloConfigurado && tituloConfigurado.trim()
				? tituloConfigurado
				: 'Disponível em outros Centro de Distribuições';
		},
        exibirIndicadorMrg: function () {
			return this.exibirPreco && this.env.roles_autorizados_visualizar_markup_pedido && this.env.roles_autorizados_visualizar_markup_pedido.includes(this.usuario.usuaRole);
		},
		descritivoHtml: function() {
            return StHelper.quebraLinha(this.descritivoProduto);
		},
        descritivoProduto: function() {
            if(!this.selecionado) return '';

            return this.selecionado.itemEspecificacoes ||
                this.selecionado.item_especificacoes ||
                (this.itemInfoComplementar && (this.itemInfoComplementar.itemEspecificacoes || this.itemInfoComplementar.item_especificacoes)) ||
                this.selecionado.itemDescritivo ||
                this.selecionado.item_descritivo;
        },
        textoAplicacao: function() {
            if(!this.descritivoProduto) return '';
            return `${this.descritivoProduto}`
                .replace(/<br\s*\/?>/gi, '\n')
                .replace(/(<([^>]+)>)/ig, '')
                .trim();
        },
		priceClass: function() {
			if (this.selecionado.depiQtdDisponivel == 0 ) return 'red-text texto-riscado';
    		else if (this.selecionado.prdtPercDesc > 0) return 'indigo-text darken-4';
    		else return '';
		},
        dimensoesProduto: function() {
            if(!this.selecionado) return '';

            let altura = this.obtemDimensao(['itemAlturaCm', 'item_altura_cm']);
            let largura = this.obtemDimensao(['itemLarguraCm', 'item_largura_cm']);
            let comprimento = this.obtemDimensao(['itemComprimentoCm', 'item_comprimento_cm', 'itemProfundidadeCm', 'item_profundidade_cm']);

            if(!altura && !largura && !comprimento) return '';

            return [
                altura ? `Altura: ${altura} cm` : null,
                largura ? `Largura: ${largura} cm` : null,
                comprimento ? `Comprimento: ${comprimento} cm` : null,
            ].filter(Boolean).join(' | ');
        },
        pesoProduto: function() {
            if(!this.selecionado) return '';

            let peso = this.obtemDimensao(['itemPeso', 'item_peso']);
            if(!peso) return '';

            return `${peso} kg`;
        },
        valoresExibicao: function () {
            if(this.ehItemPedido) {
                return {
                    valorTabela: this.calculaMarkup(this.selecionado.peddPrUnit),
                    qtdMin: this.selecionado.prdtQtdMin,
                    qtdMax: this.selecionado.prdtQtdMax,
                    percDesc: this.selecionado.peddPercDesc,
                    vlComDesc: this.calculaMarkup(this.selecionado.peddVlUnitLiq),
                    vlIcmsSt: this.selecionado.peddVlIcmsSt,
                    vlTotal: this.calculaMarkup(this.selecionado.peddVlFinal),
                    qtdDisponivel: this.limitarQuantidadeDepositos ? this.estoqueOriginalDisponivel : this.selecionado.depiQtdDisponivel,
                    unidade: this.selecionado.itemUnidade
                };
            } else {
                return {
                    valorTabela: this.calculaMarkup(this.selecionado.tabdValor),
                    qtdMin: this.selecionado.prdtQtdMin,
                    qtdMax: this.selecionado.prdtQtdMax,
                    percDesc: this.selecionado.prdtPercDesc?this.selecionado.prdtPercDesc:0,
                    vlComDesc: this.calculaMarkup(this.selecionado.prdtVlComDesc?this.selecionado.prdtVlComDesc:this.selecionado.tabdValor),
                    vlIcmsSt: this.selecionado.tempValorIcmsSt?this.selecionado.tempValorIcmsSt:0,
                    vlTotal: this.calculaMarkup(this.selecionado.tempValorTotal),
                    qtdDisponivel: this.selecionado.depiQtdDisponivel,
                    unidade: this.selecionado.itemUnidade
                };
            }
        },
        opcoesDepositoCarrinhoOrdenadas: function () {
            return ordenarPorIdDeposito(this.opcoesDepositoCarrinho);
        },
		itensDisponiveisMultiEmpresa: function () {
			if(!this.selecionado) return [];
			return ordenarPorIdDeposito([this.selecionado].concat(this.selecionado.itensMesmoSkuOutrasEmpresas || []));
		},
		opcoesEstoqueDepositos: function () {
			return ordenarPorIdDeposito(this.selecionado ? [this.selecionado].concat(this.estoquesDepositos) : []);
		},
		itensSelecionadosMultiEmpresa: function () {
			return this.itensDisponiveisMultiEmpresa.filter(opcao =>
				!this.itemJaNoPedido(opcao) && !opcao.itemTextoBloqueio && Number(opcao.quantidadeSelecionada) > 0);
		},
		quantidadeOpcoesSelecionadas: function () {
			return this.itensSelecionadosMultiEmpresa.length;
		},
		totalMultiEmpresa: function () {
			return this.itensSelecionadosMultiEmpresa.reduce((total, opcao) =>
				total + (this.valorFinalOpcao(opcao) * Number(opcao.quantidadeSelecionada)), 0);
		},
	},
	watch: {
		quantidadeSelecionada: function(newValue) {
			this.novoTotal = this.selecionado.tempValorTotal * newValue;
		},
		buscaSimples: function(newValue) {
			window.localStorage.setItem('BUSCA_SIMPLIFICADA',newValue?'S':'N');
		},
        selecionado: function(newValue) {
            this.carregarDisponibilidadeSimilares(newValue);
            this.consultaEstoquesDepositos++;
            this.estoquesDepositos = [];
            this.erroEstoquesDepositos = false;
            this.carregandoEstoquesDepositos = false;
            if(newValue) {
                this.getItemInfoComplementar(newValue);
                this.prepararQuantidadesMultiEmpresa(newValue);
                this.carregarEstoquesDepositos(newValue);
            }
		}
	},
    mounted(){
        this.carregarDisponibilidadeSimilares(this.selecionado);
        if(this.selecionado) {
            this.getItemInfoComplementar(this.selecionado);
            this.prepararQuantidadesMultiEmpresa(this.selecionado);
        }
    },
	created () {
		let factory = new ServiceFactory(this.$http);
		factory.item().then(serv=> {
			this.itemService = serv;
            this.carregarDisponibilidadeSimilares(this.selecionado);
			this.carregarEstoquesDepositos(this.selecionado);
		});
	},
	methods: {
        carregarDisponibilidadeSimilares(item) {
            const consulta = ++this.consultaSimilares;
            this.similaresDisponiveis = [];
            if (!this.similaresHabilitados || !this.itemService || !item || item.itemId == null) return;
            const cliente = this.clienteSelecionado;
            if (!cliente || !cliente.enderecoFaturamento || !this.tabelaPreco) return;
            return this.itemService.listSimilares(
                cliente.clieIdEmpr, cliente.clieIdDepo,
                cliente.enderecoFaturamento.clenEstado, this.tabelaPreco.tabcId, item.itemId
            ).then(similares => {
                if (consulta !== this.consultaSimilares || this.selecionado !== item) return;
                const sku = String(item.itemSku || '').trim().toUpperCase();
                this.similaresDisponiveis = (similares || []).filter(similar =>
                    !sku || String(similar.itemSku || '').trim().toUpperCase() !== sku);
            }).catch(err => {
                if (consulta === this.consultaSimilares) this.$emit('onError', err);
            });
        },
		nomeDeposito(item) {
			if(item.depoApelido) return item.depoApelido;
			if(item.emprNome) return item.emprNome;
			const empresa = this.clienteSelecionado && this.clienteSelecionado.empresa;
			return empresa && empresa.emprNome ? empresa.emprNome : 'Depósito principal';
		},
		carregarEstoquesDepositos(item) {
			if(!this.exibirEstoquesDepositos || !item || !item.itemSku || !this.itemService) return;
			const consulta = ++this.consultaEstoquesDepositos;
			this.carregandoEstoquesDepositos = true;
			this.erroEstoquesDepositos = false;
			this.itemService.searchSameSkuOtherCompanies([item.itemSku])
				.then(resultado => {
					if(consulta !== this.consultaEstoquesDepositos || this.selecionado !== item) return;
					const chave = Object.keys(resultado || {}).find(sku => sku.trim().toUpperCase() === item.itemSku.trim().toUpperCase());
					this.estoquesDepositos = chave ? (resultado[chave] || []).filter(opcao => opcao.itemId !== item.itemId) : [];
				})
				.catch(() => {
					if(consulta === this.consultaEstoquesDepositos) this.erroEstoquesDepositos = true;
				})
				.then(() => {
					if(consulta === this.consultaEstoquesDepositos) this.carregandoEstoquesDepositos = false;
				});
		},
		itemDaEmpresaPedidoCarrinho(item) {
			return this.emprIdPedidoCarrinho !== null && this.emprIdPedidoCarrinho !== undefined
				&& item && Number(item.emprId) === Number(this.emprIdPedidoCarrinho);
		},
		prepararQuantidadesMultiEmpresa(item) {
			if(!this.habilitarSelecaoMultiEmpresa || !item) return;
			[item].concat(item.itensMesmoSkuOutrasEmpresas || []).forEach(opcao => {
				if(opcao.quantidadeSelecionada === null || opcao.quantidadeSelecionada === undefined) {
					this.$set(opcao, 'quantidadeSelecionada', null);
				}
			});
		},
		itemJaNoPedido(item) {
			return !!(this.mapItensPedidoAberto && this.mapItensPedidoAberto[`${item.itemId}`]);
		},
		precoUnitarioOpcao(item) {
			const preco = item.prdtVlComDesc !== null && item.prdtVlComDesc !== undefined
				? item.prdtVlComDesc
				: item.tabdValor;
			return this.calculaMarkup(Number(preco) || 0);
		},
		valorFinalOpcao(item) {
			const valor = item.tempValorTotal !== null && item.tempValorTotal !== undefined
				? item.tempValorTotal
				: (item.prdtVlComDesc !== null && item.prdtVlComDesc !== undefined ? item.prdtVlComDesc : item.tabdValor);
			return this.calculaMarkup(Number(valor) || 0);
		},
		corrigirQuantidadeOpcao(item) {
            if (item.quantidadeSelecionada === '' || item.quantidadeSelecionada == null) {
                item.quantidadeSelecionada = null;
                return;
            }
			let quantidade = Number(item.quantidadeSelecionada);
			if(!Number.isFinite(quantidade) || quantidade < 0) quantidade = 0;
			const multiplo = Number(item.itemEmbMult) || 1;
			if(this.env && this.env.pedido_multiplicar_quantidade_digitada_embalagem && quantidade % multiplo !== 0) {
				quantidade = Math.ceil(quantidade / multiplo) * multiplo;
			}
			item.quantidadeSelecionada = quantidade;
            if (this.limitarQuantidadeDepositos && ajustarQuantidadeDeposito(this.selecionado,
                this.itensDisponiveisMultiEmpresa, item, this.env && this.env.pedido_multiplicar_quantidade_digitada_embalagem)) {
                Materialize.toast('Quantidade ajustada ao saldo disponível do item original e do depósito.', 4000);
            }
		},
        maximoQuantidadeDeposito(opcao) {
            return quantidadeMaximaDeposito(this.selecionado, this.itensDisponiveisMultiEmpresa, opcao);
        },
		adicionarItensMultiEmpresa() {
            if (this.limitarQuantidadeDepositos && !quantidadesDepositosValidas(this.selecionado, this.itensDisponiveisMultiEmpresa)) {
                Materialize.toast('A quantidade dos depósitos não pode exceder o estoque do item original nem o estoque de cada depósito.', 5000);
                return;
            }
			if(!this.itensSelecionadosMultiEmpresa.length) {
				Materialize.toast('Informe a quantidade em pelo menos uma empresa', 3000);
				return;
			}
			this.$emit('adicionarItensMultiEmpresa', this.itensSelecionadosMultiEmpresa.slice());
		},
        definirCorMrgDet(item) {
			let percMarkup = StHelper.calcularMrgItem(item.itemSku, item.tabdValor, item.quantidadeSelecionada, item.tabdPrecoCusto);
			const percMarkupFloat = parseFloat(percMarkup);
			const percVermelhoFloat = parseFloat(this.env.percentual_indicador_vermelho_markup_pedido);
			const percLaranjaFloat = parseFloat(this.env.percentual_indicador_laranja_markup_pedido);
			if (percMarkupFloat < percVermelhoFloat) {
				return "red-text";
			} else if (
				percMarkupFloat >= percVermelhoFloat &&
				percMarkupFloat <= percLaranjaFloat
			) {
				return "yellow-text";
			} else {
				return "green-text";
			}
		},
		checkQuantidadeDeposito() {
			if (this.env && this.env.pedido_multiplicar_quantidade_digitada_embalagem
				&& this.quantidadeSelecionada % this.selecionado.itemEmbMult != 0 )  {
					this.quantidadeSelecionada = Math.ceil(this.quantidadeSelecionada / this.selecionado.itemEmbMult)*this.selecionado.itemEmbMult;
			}

			if(this.trabalhaComListaDeFalta
				&& this.quantidadeSelecionada > this.selecionado.depiQtdDisponivel 
				&& this.selecionado.depiQtdDisponivel > 0
				) {
				//let quantidadeFalta = this.quantidadeSelecionada - this.selecionado.depiQtdDisponivel;
				let quantidadeFalta = Math.ceil( (this.quantidadeSelecionada - this.selecionado.depiQtdDisponivel) / this.selecionado.itemEmbMult) * this.selecionado.itemEmbMult;
				this.mensagemExtraAdicaoView = this.podeVisualizarQuantidadeEstoque
					? `A quantidade disponível desse produto é de ${this.selecionado.depiQtdDisponivel}, portanto a quantidade de ${quantidadeFalta} será adicionada na FALTA DE MERCADORIA.`
					: 'Parte da quantidade solicitada será adicionada na FALTA DE MERCADORIA.';
			}
		},
		adicionarCarrinhoPelaVisualizacao(item) {
            if(this.quantidadeSelecionada) {
                item.quantidadeSelecionada = this.quantidadeSelecionada;
            } else {
                item.quantidadeSelecionada = null;
            }
			this.$emit('adicionarCarrinhoPelaVisualizacao', item);
		},
        calculaMarkup(preco) {
            const { habilitar_calculo_markup_cliente } = this.env;
			const perfilCliente = this.usuario.usuaRole.toUpperCase().includes('CLIENTE');

			if(this.mostrarMarkupCliente && perfilCliente && habilitar_calculo_markup_cliente) {
				return preco * (1 + this.clienteSelecionado.clieMarkup / 100);
			}
			return preco;
		},
        obtemDimensao(campos) {
            let valor = campos
                .map(campo => this.selecionado[campo])
                .find(v => v !== null && v !== undefined && v !== '');

            if(valor === null || valor === undefined || valor === '') return '';
            return `${valor}`.replace('.', ',');
        },
        copiarAplicacao() {
            if(!this.textoAplicacao) return;

            if(navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(this.textoAplicacao)
                    .then(() => Materialize.toast('Aplicação copiada para a área de transferência', 3000))
                    .catch(() => this.copiarAplicacaoFallback());
            } else {
                this.copiarAplicacaoFallback();
            }
        },
        copiarAplicacaoFallback() {
            let input = document.createElement('textarea');
            input.value = this.textoAplicacao;
            input.setAttribute('readonly', '');
            input.style.position = 'absolute';
            input.style.left = '-9999px';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            Materialize.toast('Aplicação copiada para a área de transferência', 3000);
        },
        getItemInfoComplementar(item) {
            const itemId = this.obtemItemIdValido(item);
            if(!itemId) {
                this.itemInfoComplementar = null;
                return;
            }
			this.$http.get(`item/${itemId}`)
                .then(response=> response.json())
				.then(item => this.itemInfoComplementar = item)
				.catch(err => console.log('error: ', err))
		},
        obtemItemIdValido(item) {
            const itemId = item && typeof item === 'object' ? (item.itemId || item.id) : item;
            if(itemId === null || itemId === undefined || itemId === '' || itemId === 'null' || itemId === 'undefined') return null;
            return /^\d+$/.test(`${itemId}`) ? itemId : null;
        },
	}
}

</script>

<style scoped lang="scss">
.estoque-original-destaque {
    color: #004d40;
    font-size: 1.2rem;
}
.item-viewer-valores-grid .estoque-original-destaque strong { font-size: 1.5rem; }

.item-viewer {
    position: relative;
    padding: 0.75rem;
    border-radius: 8px;
    background: #f7f9fa;
    color: #263238;
}

.item-viewer-fechar {
    position: absolute;
    top: 0.35rem;
    right: 0.35rem;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border: 0;
    border-radius: 50%;
    background: #eceff1;
    color: #455a64;
    cursor: pointer;
}

.item-viewer-fechar:hover {
    background: #cfd8dc;
}

.item-viewer-topo {
    display: grid;
    grid-template-columns: minmax(240px, 0.8fr) minmax(0, 1.2fr);
    gap: 1.5rem;
    align-items: start;
}

.item-viewer-foto {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 280px;
    max-height: 340px;
    padding: 1rem;
    border: 1px solid #e0e7e9;
    border-radius: 8px;
    background: #fff;
}

.item-viewer-foto img {
    display: block;
    max-width: 100%;
    max-height: 305px;
    object-fit: contain;
}

.item-viewer-resumo {
    min-width: 0;
}

.item-viewer-kicker {
    color: #00897b;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

.item-viewer-nome {
    margin: 0.35rem 0 0.55rem;
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 1.25;
}

.item-viewer-identificacao {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem 1rem;
    padding-bottom: 0.8rem;
    border-bottom: 1px solid #eceff1;
    color: #607d8b;
    font-size: 0.82rem;
}

.item-viewer-identificacao strong {
    color: #37474f;
}

.item-viewer-aviso {
    margin: 0.8rem 0;
    padding: 0.65rem 0.8rem;
    border-radius: 5px;
    background: #fff3e0;
    color: #bf360c;
    font-size: 0.85rem;
}

.item-viewer-preco-principal,
.item-viewer-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

.item-viewer-preco-principal {
    padding: 0.85rem 0;
}

.item-viewer-preco-principal > span,
.item-viewer-total > span {
    color: #546e7a;
    font-weight: 600;
}

.item-viewer-preco-principal > div {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.4rem;
}

.item-viewer-preco-principal strong {
    font-size: 1.35rem;
}

.item-viewer-valores-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.55rem 1rem;
    padding: 0.8rem 0;
    border-top: 1px solid #eceff1;
}

.item-viewer-valores-grid > div {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.item-viewer-valores-grid span,
.item-viewer-valores-grid small {
    color: #607d8b;
    font-size: 0.78rem;
}

.item-viewer-valores-grid strong {
    font-size: 0.98rem;
}

.item-viewer-total {
    padding: 0.8rem 0.9rem;
    border-radius: 6px;
    background: #e0f2f1;
}

.item-viewer-total strong {
    color: #00695c;
    font-size: 1.45rem;
}

.item-viewer-adicionar-valores {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.8rem;
}

.item-viewer-adicionar-valores input {
    width: 90px;
    height: 2.25rem;
    margin: 0;
    text-align: right;
}

.item-viewer-adicionar-valores > strong {
    text-align: right;
}

.item-viewer-adicionar-acao {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin-top: 0.8rem;
}

.item-viewer-adicionar-acao .item-viewer-aviso {
    flex: 1;
    margin: 0;
}

.item-viewer-secao {
    margin-top: 1.25rem;
    padding: 1.1rem;
    border: 1px solid #e0e7e9;
    border-radius: 8px;
    background: #fff;
}

.item-viewer-secao-descricao {
    margin: -0.3rem 0 0.9rem;
    color: #607d8b;
    font-size: 0.85rem;
}

.item-viewer-tecnicos h5 {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    margin: 0 0 0.9rem;
    color: #00695c;
    font-size: 1.1rem;
    font-weight: 600;
}

.item-viewer-tecnicos-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.65rem 1.25rem;
}

.item-viewer-tecnicos-grid > div {
    min-width: 0;
    padding: 0.55rem 0;
    border-bottom: 1px solid #eceff1;
    overflow-wrap: anywhere;
}

.item-viewer-tecnicos-grid span {
    display: block;
    color: #607d8b;
    font-size: 0.78rem;
}

.item-viewer-tecnicos-grid strong {
    display: block;
    font-weight: 600;
}

.item-viewer-tecnico-largo {
    grid-column: 1 / -1;
}

.item-viewer-copiar {
    margin-left: 0.3rem;
    border: 0;
    background: transparent;
    color: #00897b;
    cursor: pointer;
    vertical-align: middle;
}

.item-viewer-copiar .material-icons {
    font-size: 1rem;
}

.multiempresa-carrinho-viewer {
    margin-top: 1.25rem;
}

.multiempresa-carrinho-viewer-title {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    margin: 0 0 0.65rem;
    color: #00796b;
    font-size: 1.15rem;
    font-weight: 600;
}

.multiempresa-carrinho-viewer-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(264px, 1fr));
    gap: 0.75rem;
}

.multiempresa-carrinho-viewer-card {
    margin: 0;
    padding: 0.9rem;
    border-top: 3px solid #00897b;
    display: flex;
    flex-direction: column;
}

.multiempresa-carrinho-viewer-card-header,
.multiempresa-carrinho-viewer-card-info {
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;
}

.multiempresa-carrinho-viewer-card-header {
    align-items: flex-start;
    padding-bottom: 0.55rem;
    border-bottom: 1px solid #e0e0e0;
}

.multiempresa-carrinho-viewer-card-header > div {
    flex: 1 1 auto;
    min-width: 0;
}

.item-viewer-remover-deposito {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    flex-shrink: 0;
    padding: 0.25rem;
    border: 0;
    background: transparent;
    cursor: pointer;
    font: inherit;
}

.multiempresa-carrinho-viewer-card-filial {
    display: inline-block;
    max-width: calc(100% - 70px);
    color: #00695c;
    font-size: 1.08rem;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
}

.multiempresa-carrinho-viewer-card-header .badge {
    float: none;
    display: inline-block;
    margin-left: 0.35rem;
    min-width: auto;
}

.multiempresa-carrinho-viewer-card-info {
    padding-top: 0.65rem;
}

.multiempresa-carrinho-viewer-card-info strong,
.multiempresa-carrinho-viewer-card-info span {
    display: block;
}

.multiempresa-carrinho-viewer-card-preco strong {
    color: #263238;
    font-size: 1.22rem;
    font-weight: 700;
}

.multiempresa-carrinho-viewer-card-preco-valor {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.4rem;
}

.prazo-entrega-adicional {
    display: inline-block !important;
    margin-left: 0.35rem;
    padding: 0.1rem 0.4rem;
    border-radius: 3px;
    background: #ffebee;
    color: #c62828;
    font-size: 0.8rem;
    font-weight: 700;
    white-space: nowrap;
}

.multiempresa-carrinho-viewer-card-estoque strong {
    font-size: 1.08rem;
    font-weight: 700;
}

.multiempresa-carrinho-viewer-card-quantidade {
    margin-top: 0.65rem;
    padding: 0.65rem 0.65rem 0.45rem;
    border: 1px solid #80cbc4;
    border-radius: 4px;
    background-color: #e0f2f1;
}

.multiempresa-carrinho-viewer-card-quantidade label {
    display: block;
    color: #00695c;
    font-size: 0.85rem;
    font-weight: 700;
}

.multiempresa-carrinho-viewer-card-quantidade input {
    margin: 0;
    height: 2.25rem;
    border-bottom-color: #00897b;
    color: #263238;
    font-size: 1.2rem;
    font-weight: 700;
    text-align: right;
}

.multiempresa-carrinho-viewer-card-quantidade input:focus {
    border-bottom-color: #00695c !important;
    box-shadow: 0 1px 0 0 #00695c !important;
}

.multiempresa-viewer {
    margin-top: 1rem;
}

.multiempresa-viewer-title {
    color: #00796b;
    display: flex;
    align-items: center;
    gap: .5rem;
}

.multiempresa-viewer-table {
    overflow-x: auto;
}

.multiempresa-viewer-quantidade {
    width: 140px;
}

.multiempresa-viewer-quantidade input {
    margin: 0;
    text-align: right;
}

.multiempresa-viewer-actions {
    margin: 1rem 0 0;
    display: flex;
    align-items: center;
}

@media only screen and (max-width: 600px) {
    .item-viewer {
        padding: 0.25rem;
    }

    .item-viewer-topo {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .item-viewer-foto {
        min-height: 220px;
        max-height: 280px;
    }

    .item-viewer-foto img {
        max-height: 245px;
    }

    .item-viewer-nome {
        font-size: 1.2rem;
    }

    .item-viewer-tecnicos-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .item-viewer-secao {
        padding: 0.85rem;
    }

    .multiempresa-carrinho-viewer-cards {
        grid-template-columns: 1fr;
    }

    .multiempresa-viewer-actions {
        display: block;
    }

    .multiempresa-viewer-actions .btn-large {
        margin-top: .75rem;
    }
}
</style>



// WEBPACK FOOTER //
// ItemViewer.vue?66c69cd9